"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setScrollY(window.scrollY * 0.5);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section id="hero" ref={heroRef} className="dark bg-background text-foreground relative h-screen w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542870/img/equicanine_rural_facility_sunrise.png)",
      transform: `translateY(${scrollY}px)`,
      transition: "transform 0.1s ease-out"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-background/60" />
      <div className="absolute inset-0 bg-gradient-radial from-transparent via-transparent to-background/40" />

      {}
      <div className="relative z-10 flex h-full items-center justify-center px-4">
        <div ref={contentRef} className={`max-w-4xl text-center transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
          <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-foreground-dark mb-6 drop-shadow-lg">
            Trusted Care for Your Horses & Dogs
          </h1>
          <p className="text-lg md:text-xl lg:text-2xl text-foreground-dark/90 mb-8 max-w-2xl mx-auto drop-shadow-md">
            Discover a spacious rural sanctuary where experienced professionals provide personalized boarding, training, and health services for your beloved companions.
          </p>
          <Link to="#services">
            <Button size="lg" className="btn-primary text-lg px-8 py-6 hover:scale-105 active:scale-100 transition-all duration-[80ms] ease-in-out shadow-medium hover:shadow-strong">
              Learn More
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}